<template>
  <v-row>
    <div
      v-if="description"
      v-html="description"
      class="description"
    >
    </div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <ValidationProvider :name="field.name" slim mode="eager" :rules="rules" v-slot="{ errors }">
          <v-text-field
            :label="`${placeholder} ${requiredHint}`"
            v-model="formattedDate"
            :error-messages="errors[0]"
            readonly
            v-on="on"
          ></v-text-field>
        </ValidationProvider>
      </template>
      <v-date-picker
        ref="dateFieldPicker"
        color="primary"
        header-color="primary"
        v-model="date"
        :max="max"
        :locale="$root.$i18n.locale.toLowerCase()"
        first-day-of-week="1"
        :active-picker="activePicker"
      ></v-date-picker>
    </v-menu>
  </v-row>
</template>


<script>
  import _ from 'lodash'
  import moment from 'moment'
  import {getFieldRules, getMaxDateField} from '@/utils/auth/validation'

  export default {
    name: 'DateField',
    props: ['field'],
    data() {
      return {
        menu: false,
        date: '',
        activePicker: ''
      }
    },
    created() {
      this.date = '';
    },
    computed: {
      placeholder() {
        return this.field.placeholder ? this.$t(this.field.placeholder) : this.field.name;
      },
      formattedDate() {
        return this.date ? moment(this.date).format('DD.MM.YYYY') : '';
      },
      requiredHint() {
        return this.field.required ? ' *' : '';
      },
      description() {
        const fieldDescription =
          _.get(this.field, 'metadata.description', '') || _.get(this.field, 'description', '')

        if (!_.isEmpty(fieldDescription)) {
          return fieldDescription
        }

        return ''
      },
      rules() {
        return getFieldRules(this.field)
      },
      max() {
        return getMaxDateField(this.field)
      }
    },
    watch: {
      date(newDate) {
        this.$emit('input', {
          key: this.field.key,
          value: newDate,
          identity: this.field.identity ? this.field.identity : false
        });
      },
      menu(value) {
        value && this.$nextTick(() => this.activePicker = 'YEAR');
      }
    }
  }
</script>

<style>

</style>
